// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as RaiseTicketRepoManager from "./RaiseTicketRepoManager.bs.js";

function raiseTicket(param, country, onSuccess, onFailure) {
  var RepoInstance = RaiseTicketRepoManager.getRaiseTicketRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.raiseTicket, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchTicketInfo(param, country, onSuccess, onFailure) {
  var RepoInstance = RaiseTicketRepoManager.getRaiseTicketRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchTicketInfo, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchTicketIssues(param, country, onSuccess, onFailure) {
  var RepoInstance = RaiseTicketRepoManager.getRaiseTicketRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchTicketIssues, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchTicketActions(param, country, onSuccess, onFailure) {
  var RepoInstance = RaiseTicketRepoManager.getRaiseTicketRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchTicketActions, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchTicketIssuesV2(param, country, onSuccess, onFailure) {
  var RepoInstance = RaiseTicketRepoManager.getRaiseTicketRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchTicketIssuesV2, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  raiseTicket ,
  fetchTicketInfo ,
  fetchTicketIssues ,
  fetchTicketActions ,
  fetchTicketIssuesV2 ,
  
}
/* RaiseTicketRepoManager Not a pure module */
